export type SelectOption = { value: string; label: string };

export const STORE_COUNTRY_OPTIONS: SelectOption[] = [
  { value: 'US', label: 'United States (US)' },
  { value: 'IN', label: 'India (IN)' },
  { value: 'GB', label: 'United Kingdom (GB)' },
  { value: 'CA', label: 'Canada (CA)' },
  { value: 'AU', label: 'Australia (AU)' },
  { value: 'AE', label: 'United Arab Emirates (AE)' },
  { value: 'SG', label: 'Singapore (SG)' },
  { value: 'DE', label: 'Germany (DE)' },
  { value: 'MY', label: 'Malaysia (MY)' },
  { value: 'ID', label: 'Indonesia (ID)' },
  { value: 'PH', label: 'Philippines (PH)' },
  { value: 'TH', label: 'Thailand (TH)' },
  { value: 'VN', label: 'Vietnam (VN)' },
  { value: 'HK', label: 'Hong Kong (HK)' },
  { value: 'NZ', label: 'New Zealand (NZ)' },
  { value: 'FR', label: 'France (FR)' },
  { value: 'ES', label: 'Spain (ES)' },
  { value: 'IT', label: 'Italy (IT)' },
  { value: 'NL', label: 'Netherlands (NL)' },
  { value: 'SE', label: 'Sweden (SE)' },
];

export const STORE_CURRENCY_OPTIONS: SelectOption[] = [
  { value: 'INR', label: 'Indian Rupee (INR)' },
  { value: 'USD', label: 'US Dollar (USD)' },
  { value: 'GBP', label: 'British Pound (GBP)' },
  { value: 'EUR', label: 'Euro (EUR)' },
  { value: 'CAD', label: 'Canadian Dollar (CAD)' },
  { value: 'AUD', label: 'Australian Dollar (AUD)' },
  { value: 'AED', label: 'UAE Dirham (AED)' },
  { value: 'SGD', label: 'Singapore Dollar (SGD)' },
  { value: 'MYR', label: 'Malaysian Ringgit (MYR)' },
  { value: 'IDR', label: 'Indonesian Rupiah (IDR)' },
  { value: 'PHP', label: 'Philippine Peso (PHP)' },
  { value: 'THB', label: 'Thai Baht (THB)' },
  { value: 'VND', label: 'Vietnamese Dong (VND)' },
  { value: 'HKD', label: 'Hong Kong Dollar (HKD)' },
  { value: 'NZD', label: 'New Zealand Dollar (NZD)' },
  { value: 'SEK', label: 'Swedish Krona (SEK)' },
];

